define.alias("ember-composable-helpers/helpers/take", "settings/helpers/take");